<template>
  <TextField
    :id="`tender-id-${planType}-${index}`"
    :name="fieldName"
    :label="translate(`${LOCALE_PREFIX}.form.tenders.tenderID`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.tenders.tenderIDPlaceholder`)"
    :required="!isDisabled"
    :disabled="isDisabled"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { SitesLocalePrefix } from '../../../../../enums';

// Define props
defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  planType: {
    type: String,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;
</script>
